
<table class="table-striped table aggiunta_classificazione">
	<caption class="sr-only">Tabella classificazione pratica</caption>
	<tr>
		<th>Materia</th>
		<th>Oggetto</th>
		<th>Argomento</th>
		<th  *ngIf="!pratica.riunita && !pratica.archiviata"></th>
	</tr>
	<ng-template [ngIf]="sezione?.classificazioni">
	<tr *ngFor="let classificazione of sezione.classificazioni">
		<td>{{ classificazione.materia.label }}</td>
		<td>{{ classificazione.oggetto.label }}</td>
		<td>{{(classificazione.argomento &&
			classificazione.argomento.label) ?
			classificazione.argomento.label: ''}}</td>
		<td>
			<div class="data_opzioni classificazione">
				<ul>
					<li [ngClass]="{'star':classificazione.isPrincipale}"></li>
					<li *ngIf="descrittore.writable && !pratica.riunita && !pratica.archiviata" class="opzioni" appDropdownFocus>
						<a class="dropdown-toggle"
							data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
							aria-expanded="false">Opzioni<span
								class="glyphicon glyphicon-option-vertical"></span></a>
						<div class="dropdown-menu">
							<ul>
								<li><span class="glyphicon glyphicon-star"></span><a href="javascript:void(0)" (click)="setClassificazionePrincipale(classificazione)">Imposta come principale</a></li>
								<li><span class="glyphicon glyphicon-pencil"></span><a href="javascript:void(0)" (click)="changeClassificazione(classificazione)">Modifica classificazione</a></li>
								<li><span class="glyphicon glyphicon-trash"></span> <a href="javascript:void(0)" (click)="removeClassificazione(classificazione.id)">Elimina</a>
								</li>
							</ul>
						</div></li>
				</ul>
			</div>
		</td>
	</tr>
	</ng-template>
</table>